export default __webpack_public_path__ + "static/media/028-sewer.fa915d34.svg";